import React from 'react';
import { ValentinePage } from './pages/ValentinePage';
export function App() {
  return <ValentinePage data-id="element-0" />;
}